export default __webpack_public_path__ + "static/media/File.08bbab68.svg";